import React from "react";
import "../styles/Header.css";
import Logo from "../assets/logoArcHeader.png";

function Header() {
  return (
    <header className="header">
      <div className="headerContainer">
        <div className="leftSection">
          <img src={Logo} alt="ARC Logo" className="logo" />
          <nav className="centerSection">
            <a href="#sobreNos">Sobre</a>
            <a href="#beneficios">Conheça</a>
            <a href="#clientes">Clientes</a>
            <a href="#pricing">Preços</a>
          </nav>
        </div>
        <div className="rightSection">
          <button className="btn-header ghost">Login</button>
          <button className="btn-header solid">Começar Agora</button>
        </div>
      </div>
    </header>
  );
}

export default Header;
